import React from "react"
import widont from "widont"

import styles from "./text.module.scss"

const Text = props => {
  const columnWidth = props.data.columnWidth
    ? `is-10-tablet is-${props.data.columnWidth}-desktop`
    : "is-10-tablet is-6-desktop"
  const isColumnCentered = props.data.centered
  const alignedLeftClasses = `${columnWidth} is-offset-1-desktop`
  const alignedCenterClasses = `${columnWidth} is-centered`
  const columnStyles = isColumnCentered
    ? alignedCenterClasses
    : alignedLeftClasses
  return (
    <div className="module">
      <div className="wrapper">
        <div
          className={`columns is-tablet is-0-mobile ${
            isColumnCentered ? "is-centered" : ""
          }`}
        >
          <div
            className={`column ${columnStyles} ${
              props.data.textCentered ? "text-center" : ""
            }`}
          >
            {props.data.subhead && (
              <p className={`subhead ${styles.subhead}`}>
                {props.data.subhead}
              </p>
            )}
            {props.data.heading && (
              <h2
                className={`h-2 h--cms-title ${styles.heading}`}
                dangerouslySetInnerHTML={{
                  __html: widont(props.data.heading),
                }}
              />
            )}
            {props.data.body && (
              <div
                className="user-content"
                dangerouslySetInnerHTML={{
                  __html: widont(props.data.body),
                }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Text
